import { c as _c } from "react/compiler-runtime";
import './commitment-card.scss';
import { useTranslation } from 'react-i18next';
import { ItemCard, ItemCardDivider, ItemCardFooter } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { NumberField } from '@sola/ark-core/molecules/number-field/number-field.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentCardInfoSection } from '../commitment-card-info-section/commitment-card-info-section.tsx';
export const CommitmentCardPayment: React.FC<{
  commitment: GraphQLCommitment;
}> = t0 => {
  const $ = _c(23);
  const {
    commitment
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("core:forms.errors.amountLimitsMin", {
      min: 0
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const amountMinLimitMsg = t2;
  let t3;
  if ($[3] !== commitment) {
    t3 = <CommitmentCardInfoSection commitment={commitment} useRate={false} />;
    $[3] = commitment;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ItemCardDivider />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== amountMinLimitMsg) {
    t5 = {
      value: 0,
      message: amountMinLimitMsg
    };
    $[6] = amountMinLimitMsg;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== commitment.internalId || $[9] !== t5) {
    t6 = <NumberField inputClasses="CommitmentPaymentCard__input" name={commitment.internalId} prefix="$" label="Enter payment amount" placeholder="0" step="1" isCurrency={false} min={t5} />;
    $[8] = commitment.internalId;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== commitment.dueThisMonthAmount || $[12] !== commitment.hasDueThisMonth || $[13] !== commitment.hasMissedPayment || $[14] !== commitment.missedPaymentAmount || $[15] !== t) {
    t7 = commitment.hasMissedPayment && commitment.hasDueThisMonth && <p className="mt-snug-lg label-mild label-md label-neutral-moderate">{t("makeAPayment.hint", {
        missedPayment: t("numbers.currencyCustom", {
          amount: commitment.missedPaymentAmount
        }),
        dueThisMonth: t("numbers.currencyCustom", {
          amount: commitment.dueThisMonthAmount
        })
      })}</p>;
    $[11] = commitment.dueThisMonthAmount;
    $[12] = commitment.hasDueThisMonth;
    $[13] = commitment.hasMissedPayment;
    $[14] = commitment.missedPaymentAmount;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <ItemCardFooter justify="between"><div>{t6}{t7}</div></ItemCardFooter>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t8) {
    t9 = <ItemCard>{t3}{t4}{t8}</ItemCard>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};